import { Pipe, PipeTransform } from '@angular/core';

import { AssociationNamesEntity } from '@cjm/v-loket/shared';

@Pipe({
	name: 'associationName',
	standalone: true
})
export class AssociationNamePipe implements PipeTransform {
	/**
	 * Selects the name of the association from the name object.
	 *
	 * This process will follow the following priority
	 * 1. Callname
	 * 2. Short name
	 * 3. Full name
	 *
	 * @param names{AssociationNamesEntity} The name object to select the name from
	 * @param format{'single' | 'full'} The format of the name to return. 'single' will return the first name found, 'full' will return the short/callname with the full name appended
	 * @returns {string} The name of the association
	 */
	public transform(names: AssociationNamesEntity, format: 'single' | 'full' = 'single'): string {
		if (names?.callName && names?.short) {
			return `${names.short} - ${names.callName}`;
		}

		if (names?.callName) {
			return format === 'single' ? names.callName : `${names.callName} - ${names.full}`;
		}

		if (names?.short) {
			return format === 'single' ? names.short : `${names.short} - ${names.full}`;
		}

		return names?.full || '';
	}
}
